<template>
  <div class="container">
    <div class="left-box">
      <titleSwitch v-model="questionKey" :itemList="questionList" />
      <div class="question-box" v-if="curQuestion">
        <div class="question-title">
          <span class="red-black-text">{{
            curQuestion ? curQuestion.name : ""
          }}</span>
        </div>
        <div class="question-tips" v-if="curQuestion.tips">
          <autoTitle runTimeSecondLenght="10" textAlign="center">
            {{ getDict(402) /*競猜TIPS*/ }}:{{ curQuestion.tips }}
          </autoTitle>
        </div>
        <div class="option-box">
          <div class="option-line">
            <div class="arrow left">
              <div
                class="btn"
                :class="['none', '', 'disabled'][optionArrowStatus[0]]"
                @click="
                  () => {
                    optionArrowStatus[0] == 1 && move(-1);
                  }
                "
              ></div>
            </div>
            <div
              class="option-list"
              :class="optionStatus.moveing ? 'moveing' : ''"
              @scroll="onMove"
              ref="opList"
            >
              <div
                class="scroll-box"
                :class="optionListScrollBoxClass"
                ref="opListScrollBox"
              >
                <div class="scroll-inner-box">
                  <div
                    class="option-item"
                    :class="{
                      active: questionSelected.includes(item.op_id),
                    }"
                    v-for="(item, index) in optionLists[0]"
                    @click="selectOption(item)"
                    :key="index"
                  >
                    <div class="info">
                      <img :src="item.icon" v-if="!!item.icon" />
                      <span>{{ item.name || "" }}</span>
                    </div>
                    <div class="rate">
                      <span>
                        {{ getDict(235) /*赔率*/
                        }}{{
                          item.rate > 9999 ? "9999+" : item.rate.toFixed(2)
                        }}
                      </span>
                    </div>
                    <div
                      class="question-selected-mask selected"
                      :class="questionSelectClicked ? 'flash' : ''"
                      v-if="questionSelected.includes(item.op_id)"
                    ></div>
                    <div class="true-question-mask" v-if="item.is_answer">
                      <div class="text">
                        <span class="red-black-text">{{
                          getDict(236) /*本轮结果*/
                        }}</span
                        ><span class="tick-icon"></span>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="vs" v-if="questionOptionList.length == 2"></div> -->
                <div class="scroll-inner-box">
                  <div
                    class="option-item"
                    :class="{
                      active: questionSelected.includes(item.op_id),
                    }"
                    v-for="(item, index) in optionLists[1]"
                    @click="selectOption(item)"
                    :key="index"
                  >
                    <div class="info">
                      <img :src="item.icon" v-if="!!item.icon" />
                      <span>{{ item.name || "" }}</span>
                    </div>
                    <div class="rate">
                      <span>
                        {{ getDict(235) /*赔率*/
                        }}{{
                          item.rate > 9999 ? "9999+" : item.rate.toFixed(2)
                        }}
                      </span>
                    </div>
                    <div
                      class="question-selected-mask selected"
                      :class="questionSelectClicked ? 'flash' : ''"
                      v-if="questionSelected.includes(item.op_id)"
                    ></div>
                    <div class="true-question-mask" v-if="item.is_answer">
                      <div class="text">
                        <span class="red-black-text">{{
                          getDict(236) /*本轮结果*/
                        }}</span
                        ><span class="tick-icon"></span>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="option-item holder"></div> -->
              </div>
            </div>
            <div class="arrow right">
              <div
                class="btn"
                :class="['none', '', 'disabled'][optionArrowStatus[1]]"
                @click="
                  () => {
                    optionArrowStatus[1] == 1 && move(1);
                  }
                "
              ></div>
            </div>
          </div>
          <div class="bottom-info">
            <span class="time-text" v-if="bottomTimeInfoText"
              ><i class="icon-time icon" />{{ bottomTimeInfoText }}</span
            >
            <div
              v-if="optionArrowStatus[0]"
              class="icon-more-2 more"
              @click="popAllOption = true"
            ></div>
          </div>
        </div>
      </div>
      <div class="gamble-ctrl" v-if="!gameEnd">
        <div class="num-ctrl">
          <div class="subtract" @click="subtractQuizGold"></div>
          <div class="num">
            <span class="red-black-text">{{ quizGold }}</span>
          </div>
          <div class="add" @click="addQuizGold"></div>
        </div>
        <div
          class="button-bg done-btn"
          :class="hasNotQuiz ? '' : 'disabled'"
          @click="quizDone"
        >
          <span class="red-black-text">{{
            hasNotQuiz ? getDict(238) /*竞 猜*/ : getDict(239) /*已投注*/
          }}</span>
        </div>
      </div>
      <div class="gamble-ctrl end" v-else>
        {{ getDict(237) /*竞猜已结束*/ }}
      </div>
      <div class="player-count">
        {{
          getDict(240, [
            (curQuestion ? curQuestion.join_count : 0) || 0,
          ]) /*已有1234567人参与*/
        }}
      </div>
    </div>
    <div class="right-box">
      <div class="right-box-title">
        <span class="linear-text">{{ getDict(400) /* 赛事信息 */ }}</span>
      </div>
      <div class="team-top">
        <autoTitle runTimeSecondLenght="10" textAlign="center">
          <span class="linear-text">{{ teamTitle }}</span>
        </autoTitle>
      </div>
      <div class="team-box">
        <div class="team-list">
          <div v-for="team of teamList" :key="team.tid" class="team-item">
            <img :src="team.icon" />
          </div>
          <!-- <template v-for="i in 30">
          </template> -->
        </div>
      </div>
      <div class="ctrl-box">
        <div
          class="button-bg done-btn"
          v-if="teamJumpVideoId"
          @click="gotoLiveBroadcast"
        >
          <span class="red-black-text">{{ getDict(401) /* 前往直播 */ }}</span>
        </div>
      </div>
    </div>
    <gamblePopComp :show="popAllOption" @close="popAllOption = false">
      <div class="option-all-pop" @click.stop>
        <div class="option-all-list">
          <div class="scroll-box">
            <div
              class="option-item"
              :class="{
                active: questionPopSelected.includes(item.op_id),
              }"
              v-for="(item, index) in questionOptionList"
              @click="selectPopOption(item)"
              :key="index + '' + item.op_id"
            >
              <div class="info">
                <img :src="item.icon" v-if="!!item.icon" />
                <span>{{ item.name || "" }}</span>
              </div>
              <div class="rate">
                {{ getDict(235) /*赔率*/
                }}{{ item.rate > 9999 ? "9999+" : item.rate.toFixed(2) }}
              </div>
              <div
                class="question-selected-mask selected"
                :class="questionPopSelectClicked ? 'flash' : ''"
                v-if="questionPopSelected.includes(item.op_id)"
              ></div>
              <div class="true-question-mask" v-if="item.is_answer">
                <div class="text">
                  <span class="red-black-text">{{
                    getDict(236) /*本轮结果*/
                  }}</span
                  ><span class="tick-icon"></span>
                </div>
              </div>
            </div>
            <div
              class="option-item holder"
              v-for="(i, index) in 7"
              :key="index"
            ></div>
          </div>
        </div>
        <div class="select-ctrl">
          <div class="button-bg done-btn" @click="selectPopOptionDone">
            {{ getDict(241) /*确 定*/ }}
          </div>
          <div class="close-btn" @click="popAllOption = false"></div>
        </div>
      </div>
    </gamblePopComp>
    <gamblePopComp
      v-if="!!popMessage"
      :show="true"
      boxType="box"
      @close="popMessage = ''"
    >
      <div class="popMsgBox">
        <span>{{ popMessage }}</span>
      </div>
    </gamblePopComp>
    <gamblePopComp
      v-if="quizReslut.show"
      :show="true"
      boxType="title"
      :title="getDict(242) /*竞猜*/"
      @close="quizReslut.show = false"
    >
      <div class="quiz-result">
        <span class="name">{{ quizReslut.name }}</span>
        <span class="desc">{{ quizReslut.desc }}</span>
        <div class="button-bg done-btn" @click="quizReslut.show = false">
          {{ getDict(241) /*确 定*/ }}
        </div>
      </div>
    </gamblePopComp>
    <gamblePopComp
      v-if="noEnoughtGold"
      :show="true"
      boxType="box"
      @close="noEnoughtGold = false"
    >
      <div class="no-enought-gold popMsgBox">
        <span class="name">{{ getDict(243) /*竞猜币不足*/ }}</span>
        <div class="button-bg done-btn goto-get-gold" @click="gotoGetGold">
          {{ getDict(245) /*获取竞猜币*/ }}
        </div>
      </div>
    </gamblePopComp>
  </div>
</template>

<script>
import {
  getDict,
  formatDate,
  dateDuration,
  isToday,
  axios,
  getPageLevelMixin,
  webSocket,
  serverApi,
} from "../../../../common";
import store from "@/store";
import { mapState, mapGetters } from "vuex";
import titleSwitch from "../../comps/title-switch";
import AutoTitle from "../../../../components/autoTitle";

import gamblePopComp from "../../comps/gamble-pop-comp";

let moveTime = 0.7;
export default {
  name: "quizPage",
  mixins: [getPageLevelMixin],
  props: {},
  data() {
    return {
      popMessage: "",
      pageLevel: 1,

      quizReslut: {
        show: false,
        name: "",
        desc: "",
      },
      noEnoughtGold: false,

      optionStatus: {
        width: 0,
        boxWidth: 0,
        left: 0,
        moveing: false,
      },
      now: new Date().getTime(),

      quizGoldSize: 100,
      quizGold: 100,

      questionKey: undefined,
      questionList: [
        // {
        //   name:'1',
        //   key:'1',
        // },{
        //   name:'2',
        //   key:'2',
        // },{
        //   name:'3',
        //   key:'3',
        // },{
        //   name:'4',
        //   key:'4',
        // },
      ],
      popAllOption: false,
      questionPopSelectClicked: false,
      questionPopSelected: [],
      questionSelectClicked: false,
      questionSelected: [],
      questionOptionList: [
        // ...Array(7).fill({}).map((item,index)=>{
        //   item = {
        //     op_id:index,
        //     name:'op' + index,
        //     icon:index%5?'https://nie.res.netease.com/r/pic/20200603/187bb5a3-5d56-4577-b2f7-552f83c10846.png':'',
        //     rate:0.12,
        //     is_answer:index == 2,
        //   }
        //   return item;
        // })
      ],
      hasQuiz: false,
    };
  },
  computed: {
    ...mapState(["userData"]),
    ...mapState({
      teamList: (state) => state.gambleObject.teamObj.teamList,
      teamTitle: (state) => state.gambleObject.teamObj.title,
      teamJumpVideoId: (state) => state.gambleObject.teamObj.videoId,
    }),
    ...mapGetters([
      "gambleCompetitionList",
      "gambleActiveCompetition",
      "gambleActiveCompetitionQuestionList",
      "nowTs",
    ]),
    curGame() {
      return (
        this.gambleCompetitionList &&
        this.gambleCompetitionList.find((game) => game.cid == this.activeGameId)
      );
    },
    optionArrowStatus() {
      if (this.optionStatus.boxWidth >= this.optionStatus.width) {
        return [0, 0];
      }
      return [
        this.optionStatus.left > 0 ? 1 : 2,
        this.optionStatus.left + this.optionStatus.boxWidth + 1 <
        this.optionStatus.width
          ? 1
          : 2,
      ];
    },
    optionLists() {
      let index = Math.ceil(this.questionOptionList.length / 2);
      return [
        this.questionOptionList.slice(0, index),
        this.questionOptionList.slice(index),
      ];
    },
    optionListScrollBoxClass() {
      return this.questionOptionList.length == 2
        ? "has-vs"
        : this.optionArrowStatus[0] || this.optionArrowStatus[1]
        ? ""
        : "align-content-center";
    },
    curQuestion() {
      return this.gambleActiveCompetitionQuestionList.find(
        (question) => question.qid == this.questionKey
      );
    },
    hasNotQuiz() {
      return !this.hasQuiz;
    },
    gameEnd() {
      return !this.curQuestion || this.curQuestion.cut_ts * 1000 < this.nowTs;
    },
    bottomTimeInfoText() {
      if (!this.curQuestion) {
        return "";
      }
      if (
        this.curQuestion.start_ts &&
        this.curQuestion.start_ts * 1000 > this.nowTs
      ) {
        return formatDate(
          this.curQuestion.start_ts * 1000,
          getDict(247, ["DD", "HH"]) /*竞猜开始时间：DD日HH时*/
        );
      }
      if (
        this.curQuestion.cut_ts &&
        this.curQuestion.cut_ts * 1000 > this.nowTs
      ) {
        if (isToday(this.curQuestion.cut_ts * 1000)) {
          return dateDuration(
            this.curQuestion.cut_ts * 1000 - this.nowTs,
            getDict(257, ["HH", "mm"]) /*'距离竞猜关闭还有DD日HH时mm分'*/
          );
        } else {
          return dateDuration(
            this.curQuestion.cut_ts * 1000 - this.nowTs,
            getDict(246, ["DD", "HH", "mm"]) /*'距离竞猜关闭还有DD日HH时mm分'*/
          );
        }
      }
    },
  },
  watch: {
    gambleActiveCompetitionQuestionList() {
      this.initQuestionList();
    },
    questionList() {
      this.questionKey = this.questionList[0]
        ? this.questionList[0].key
        : undefined;
    },
    curQuestion() {
      // console.log(123123123);
      this.questionSelected = [];
      if (this.curQuestion) {
        this.questionOptionList = this.curQuestion.options;
        if (this.curQuestion.chosen) {
          this.questionSelected = [this.curQuestion.chosen.op_id];
          this.hasQuiz = true;
        } else {
          this.hasQuiz = false;
        }
      } else {
        this.questionOptionList = [];
        this.hasQuiz = false;
      }
    },
    optionLists() {
      this.$nextTick(() => {
        this.resetOptionStatus(true);
      });
    },
    optionListScrollBoxClass() {
      if (this.optionListScrollBoxClass == "") {
        this.$nextTick(() => {
          this.resetOptionStatus(true);
        });
      }
    },
    popAllOption() {
      if (this.popAllOption) {
        this.questionPopSelected = [...this.questionSelected];
      }
    },
  },
  methods: {
    getDict,
    initQuestionList() {
      this.questionList = this.gambleActiveCompetitionQuestionList.map(
        (question, index) => ({
          name: getDict(258) /* 问题 */ + (index + 1),
          key: question.qid,
        })
      );
    },
    onMove() {
      this.resetOptionStatus();
    },
    resetOptionStatus(widthChange = false) {
      if (!this.$refs.opList) {
        return;
      }
      if (widthChange) {
        this.optionStatus.boxWidth = this.$refs.opList.clientWidth;
        this.optionStatus.width = this.$refs.opList.scrollWidth;
      }
      this.optionStatus.left = this.$refs.opList.scrollLeft;
    },
    selectPopOption(item) {
      if (this.gameEnd || !this.hasNotQuiz) {
        return;
      }
      this.questionPopSelected = [item.op_id];
      this.questionPopSelectClicked = false;
      setTimeout(() => {
        this.questionPopSelectClicked = true;
      }, 50);
    },
    selectPopOptionDone() {
      this.popAllOption = false;
      this.questionSelected = [...this.questionPopSelected];
      this.questionPopSelected = [];
    },
    selectOption(item) {
      if (this.gameEnd || !this.hasNotQuiz) {
        return;
      }
      this.questionSelected = [item.op_id];
      this.questionSelectClicked = false;
      setTimeout(() => {
        this.questionSelectClicked = true;
      }, 50);
    },
    move(arrow = 0) {
      if (this.optionStatus.moveing) {
        return;
      }
      // debugger
      let length = 0;
      if (arrow > 0) {
        length = Math.min(
          this.optionStatus.boxWidth / 2,
          this.optionStatus.width -
            this.optionStatus.left -
            this.optionStatus.boxWidth
        );
      }
      if (arrow < 0) {
        length = Math.min(
          this.optionStatus.boxWidth / 2,
          this.optionStatus.left
        );
      }
      if (length) {
        this.optionStatus.moveing = true;
        if (arrow > 0) {
          this.$refs.opList.scrollLeft += length; //opListScrollBox
          this.$refs.opListScrollBox.style.transform = `translateX(${length}px)`;
        } else {
          this.$refs.opList.scrollLeft -= length;
          this.$refs.opListScrollBox.style.transform = `translateX(${-length}px)`;
        }
        setTimeout(() => {
          this.$refs.opListScrollBox.style.transition = `${moveTime}s `; //Linear  ease-out
          this.$refs.opListScrollBox.style.transform = `translateX(0px)`;

          setTimeout(() => {
            this.$refs.opListScrollBox.style.transition = ``;
            this.optionStatus.moveing = false;
          }, moveTime * 1000);
        }, 0);
      }
    },
    subtractQuizGold() {
      this.quizGold -= this.quizGoldSize;
      if (this.quizGold < this.quizGoldSize) {
        this.quizGold = this.quizGoldSize;
      }
    },
    addQuizGold() {
      this.quizGold += this.quizGoldSize;
    },
    gotoGetGold() {
      this.noEnoughtGold = false;
      this.$emit("gotoGetGold");
    },
    gotoLiveBroadcast() {
      if (this.teamJumpVideoId) {
        this.$router.push(`/liveBroadcast/${this.teamJumpVideoId}`);
      }
    },

    //------------api
    async quizDone() {
      if (!this.hasNotQuiz) {
        return;
      }
      if (!this.curQuestion) {
        return;
      }
      if (this.curQuestion.start_ts * 1000 > this.nowTs) {
        this.quizReslut.name = getDict(248) /* 竞猜尚未开始 */;
        this.quizReslut.desc = formatDate(
          this.curQuestion.start_ts * 1000,
          getDict(249, [
            isToday(this.curQuestion.start_ts * 1000)
              ? getDict(250)
              : getDict(251, ["MM", "DD"]),
            "HH:mm",
          ])
        );
        /* `本竞猜将于东京时间${
            isToday(this.curQuestion.start_ts * 1000) ? "今日" : "MM月DD日"
          } HH:mm开始` */
        this.quizReslut.show = true;
        return;
      }
      if (!this.questionSelected[0]) {
        this.popMessage = getDict(252) /* 请选择竞猜对象 */;
        return;
      }
      let res = await serverApi.post("quiz", {
        qid: this.curQuestion.qid,
        op_id: this.questionSelected[0],
        gold: this.quizGold,
      });
      // debugger;
      if (res.code == 200) {
        this.quizReslut.name = getDict(253);
        this.quizReslut.desc = formatDate(
          this.gambleActiveCompetition.start_ts * 1000,
          // this.curQuestion.start_ts * 1000,
          getDict(254, [
            // isToday(this.curQuestion.start_ts * 1000)
            isToday(this.gambleActiveCompetition.start_ts * 1000)
              ? getDict(250)
              : getDict(251, ["MM", "DD"]),
            "HH:mm",
          ])
        );
        /* `本赛事将于东京时间${
            isToday(this.curQuestion.start_ts * 1000) ? "今日" : "MM月DD日"
          } HH:mm开始，敬请期待！` */
        this.quizReslut.show = true;
        store.dispatch("gambleGetupdateQuestion", this.curQuestion.qid);
      } else {
        switch (res.code) {
          case 40002:
            this.noEnoughtGold = true;
            break;
          case 40004: //时间不对
            this.popMessage = getDict(256) /* 當前時間無法兌換 */;
            break;
          case 40005:
            this.popMessage = getDict(255) /* 你已投注 */;
        }
      }
      store.dispatch("gambleGetUserInfo");
    },
  },
  components: {
    titleSwitch,
    gamblePopComp,
    AutoTitle,
  },
  mounted() {
    this.$busOn("setRemUnit", () => {
      //$busOn
      this.resetOptionStatus(true);
    });
    this.$nextTick(() => {
      this.resetOptionStatus(true);
    });
  },
  created() {
    this.initQuestionList();
    // window.store = store;
  },
};
</script>

<style lang="scss" scoped>
.red-black-text {
  position: relative;
  background-image: -webkit-linear-gradient(-104deg, #5c1413, #e04445);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.linear-text {
  background-image: -webkit-linear-gradient(bottom, #ffd266, #a98117);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.done-btn {
  width: 1.77rem;
  height: 0.48rem;
  line-height: 0.48rem;
  font-size: 0.26rem;
  text-align: center;
  font-weight: 600;
}
.container {
  display: flex;
  flex: 1;
  height: 0;
  align-items: stretch;

  .left-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    // height: 100%;

    width: 0;
    flex: 1;

    .question-box {
      // $width:11rem;
      // width: $width;
      // height: $width * (319/1118);
      width: 100%;
      min-height: 0;
      flex: 1;

      display: flex;
      flex-direction: column;

      .question-title {
        background: url(./imgs/question-top-bg.png) no-repeat;
        background-size: 100% 100%;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 0.93rem;
        &::before {
          // z-index: -1;
          height: 100%;
          width: 100%;
          right: 0;
          bottom: 0;
          content: "";
          background: url(./imgs/quiz.png) no-repeat;
          background-size: 2.45rem 0.66rem;
          background-position: center;
          position: absolute;
        }
        width: 100%;
        // height: 0.88rem;
        min-height: 0.88rem;
        padding: 0.1rem;
        line-height: 0.88rem;
        font-size: 0.3rem;
        line-height: 1.2em;
        font-weight: 600;
        text-align: center;

        /* span {
          position: relative;

          background-image: -webkit-linear-gradient(-104deg, #5c1413, #e04445);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        } */
      }
      .question-tips {
        height: 0.49rem;
        line-height: 0.49rem;
        margin-bottom: 0.04rem;
        background: url(./imgs/tips-bg.png) no-repeat;
        background-size: 100% 100%;
        text-align: center;
        font-size: 0.18rem;
        color: #fff;
      }
      .option-box {
        width: 100%;
        min-height: 0;
        flex: 1;
        display: flex;
        flex-direction: column;
        background: url(./imgs/question-bottom-bg.png) no-repeat;
        background-size: 100% auto;
        background-position: bottom;
 
        position: relative;
        &::after {
          content: "";
          pointer-events: none;
          box-sizing: border-box;
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          border: 0.01rem rgba(#ffeb77,0.7) solid;

          mask: linear-gradient(150deg, #000 0%, rgba(0, 0, 0, 0.2) 20%);
        }
        .option-line {
          // width: $width;
          // height: 4rem;//1.72rem;
          width: 100%;
          flex: 1;
          min-height: 0;
          display: flex;
          align-items: stretch;
          justify-content: space-between;
          .arrow {
            flex-shrink: 0;
            display: flex;
            align-items: center;

            .btn {
              width: 0.36rem;
              height: 1.4rem;
              background: url(./imgs/arrow.png) no-repeat;
              background-size: 100% 100%;

              &.disabled {
                background-image: url(./imgs/arrow-disabled.png);
              }
              &.none {
                opacity: 0;
              }
            }

            &.right {
              transform: scaleX(-1);
            }
          }
          .option-list {
            flex: 1;
            width: 0;
            // height: 100%;
            overflow-x: auto;
            overflow-y: hidden;

            &.moveing {
              overflow: hidden;
            }
            margin: 0.15rem 0.1rem -0.5rem;
            padding-bottom: 0.5rem + 0.15rem;
            display: flex;
            // align-items: center;
            align-items: stretch;
            .scroll-box {
              // flex: 1;
              // display: flex;
              // flex-wrap: nowrap;

              // margin: 0 -0.1rem -0.5rem;
              margin-bottom: -0.5rem;
              justify-content: center;
              &.has-vs {
                flex-direction: row;
                align-items: center;
              }
              &.align-content-center {
                align-content: center;
              }

              flex-direction: column;
              // flex-wrap: wrap;
              // height: 100%;

              .vs {
                width: 0.66rem;
                height: 0.63rem;
                background: url(./imgs/vs.png) no-repeat;
                background-size: 100% 100%;
                margin: 0 0.3rem 0.5rem;
              }
              .scroll-inner-box {
                display: flex;
                // margin:0 -1rem;

                &:first-child {
                  // justify-content: flex-end;
                }
              }
            }
            .option-item {
              margin: 0 0.1rem 0.5rem;
              // &:first-child{
              //   margin-left:0;
              // }

              &.holder {
                width: 0;
                padding-left: 0;
                padding-right: 0;
                margin-left: 0;
                margin-right: 0;
              }
            }
          }
        }
        .bottom-info {
          color: #767676;
          $height: 0.3rem;
          $line-height: 0.22rem;
          line-height: $line-height;
          height: $height;
          flex-shrink: 0;
          font-size: 0.2rem;
          position: relative;
          margin: 0.15rem 0;
          text-align: center;
          .time-text {
            display: inline-block;
            // height: 0.3rem;
          }
          .icon {
            font-size: $line-height;
            vertical-align: bottom;
            margin-right: 0.1rem;
          }
          .more {
            position: absolute;
            right: 0.1rem;
            bottom: 0;
            font-size: 0.36rem;
          }
        }
      }
    }

    .gamble-ctrl {
      margin: 0.2rem 0;
      display: flex;
      height: 0.56rem;
      justify-content: center;
      align-items: center;

      font-size: 0.26rem;
      &.end {
        font-size: 0.26rem;
        font-weight: 600;
        color: #676767;
      }
      .num-ctrl {
        $height: 0.48rem;
        $btn-color: #f2f2f1;
        $btn-text-color: $btn-color; //#ffa42b;
        $bg-color: $btn-color; //#bdbab9;
        $color: #292829;
        $size0: 0.04rem;
        $size1: 0.26rem;
        display: flex;
        align-items: center;

        height: $height;

        border: solid $btn-color;
        border-width: 0.02rem;
        // background-color: $btn-color;
        .subtract,
        .add {
          box-sizing: content-box;
          // background-color: $btn-color;
          width: $height;
          height: $height;
          position: relative;

          &::before,
          &::after {
            position: absolute;
            display: block;
            content: "";
            background-color: $btn-text-color;
          }

          &::before {
            height: $size0;
            width: $size1;
            left: ($height - $size1)/2;
            top: ($height - $size0)/2;
          }
        }
        .subtract {
          // border-right: 0.03rem solid $btn-color;
        }
        .add {
          // border-left: 0.03rem solid $btn-color;
          &::after {
            height: $size1;
            width: $size0;
            left: ($height - $size0)/2;
            top: ($height - $size1)/2;
          }
        }
        .num {
          width: $height * 2;
          height: 100%;
          color: $color;
          background-color: $bg-color;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }

      .done-btn {
        margin-left: 0.3rem;
        height: 0.48rem;
        width: 1.78rem;
        line-height: 0.48rem;
        text-align: center;
        font-weight: 600;
        color: #282728;

        &.disabled {
          filter: grayscale(100%);
        }
      }
    }
    .player-count {
      height: 0.3rem;
      color: #cecece;
      font-size: 0.2rem;
      text-align: center;
      margin-bottom: 0.2rem;
    }
  }

  .right-box {
    flex-shrink: 0;
    $right-width: 2.96rem;
    width: $right-width;
    margin-left: 0.04rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 0.5rem;
    .right-box-title {
      $height: 0.43rem;
      margin: 0.2rem 0;
      width: 100%;
      background-color: rgba(#ededf5, 0.15);
      text-align: center;
      font-size: 0.2rem;
      line-height: $height;

      position: relative;
      &::after {
        content: "";
        box-sizing: border-box;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        border: 0.01rem rgba(#ffeb77, 0.5) solid;

        mask: linear-gradient(
          -30deg,
          #000 0%,
          rgba(0, 0, 0, 0.2) 30%,
          rgba(0, 0, 0, 0.2) 70%,
          #000 100%
        );
      }
      span {
        position: relative;
      }
    }
    .team-top {
      background-image: url(./imgs/team-top-bg.png);
      font-size: 0.28rem;
      font-weight: 600;
      width: 100%;
      height: 0.92rem;
      line-height: 0.92rem;
      text-align: center;
      background-size: 100% 100%;

      position: relative;
      &::after {
        content: "";
        box-sizing: border-box;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        border: 0.01rem rgba(#ffeb77, 0.5) solid;

        mask: linear-gradient(
          -30deg,
          #000 0%,
          rgba(0, 0, 0, 0.2) 30%,
          rgba(0, 0, 0, 0.2) 70%,
          #000 100%
        );
      }
    }
    .team-box {
      width: 100%;
      background-image: url(./imgs/team-bg.png);
      // font-size: 0.28rem;
      // font-weight: 600;
      // width: 100%;
      // height: 0.92rem;
      // line-height: 0.92rem;
      // text-align: center;
      background-size: cover;
      background-repeat: no-repeat;
      background-position-y: bottom;
      background-position-x: right;
      flex-grow: 1;
      height: 0;
      display: flex;
      align-items: stretch;

      .team-list {
        // height: 100%;
        width: 100%;
        margin: 0.02rem 0;
        display: flex;
        flex-wrap: wrap;
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;
        // justify-content: space-between;

        @mixin item-mask {
          $linear-deg: -45;
          mask: linear-gradient(
            #{$linear-deg * 1deg},
            transparent 10%,
            #000 10%,
            #000 90%,
            transparent 90%
          );
        }
        .team-item {
          margin: 0.02rem;
          $size: 0.55rem;
          width: $size;
          height: $size;
          background-color: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0.02rem;
          @include item-mask;
          img {
            width: 100%;
            height: 100%;
            @include item-mask;
          }
        }
      }
    }
    .ctrl-box {
      height: 0.56rem;
      margin: 0.2rem 0;
      display: flex;
      align-items: center;
    }
  }

  .scroll-box {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    .option-item {
      flex-shrink: 0;
      display: inline-block;
      $height: 1.42rem;
      $width: 1.32rem;
      height: $height;
      width: $width;
      $info-height: 0.95rem;

      position: relative;

      &:not(.active) {
        &::after {
          content: "";
          box-sizing: border-box;
          position: absolute;
          top: 0;
          width: 100%;
          height: 100%;
          border: #c0833a solid 1px;
          // z-index: 1;
        }
      }
      .selected {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
      }
      .true-question-mask {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background: url(./imgs/true-option-mask.png) no-repeat;
        background-size: 100% 100%;
        $color: #7a4500;
        .text {
          position: absolute;
          left: 0;
          top: 100%;
          $true-question-mask-text-height: 0.4rem;
          width: 100%;
          height: $true-question-mask-text-height;
          background: url(./imgs/true-option-mask-bottom.png) no-repeat;
          background-size: 100% 100%;

          line-height: $true-question-mask-text-height;
          text-align: center;
          font-size: 0.2rem;
          font-weight: 600;
          color: $color;
        }
        .tick-icon {
          display: inline-block;
          width: 1em;
          height: 0.5em;
          margin-left: 0.2em;
          transform: translateY(-0.2em) rotate(-45deg);
          border: 0.03rem solid $color;
          border-top: 0;
          border-right: 0;
        }
      }

      .info {
        width: 100%;
        height: $info-height;
        color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        // text-align: center;
        font-size: 0.22rem;
        position: relative;
        background-color: rgba(#262831, 0.4);
        // background-image: -webkit-linear-gradient(bottom, #7d8083, #292829);
        img {
          // width:100%;
          // height: 100%;
          $size: 0.5rem;
          width: $size;
          height: $size;
          border-radius: 50%;
        }
        span {
          // position: absolute;
          // bottom: 0.05rem;
          width: 100%;
          left: 0;
          text-align: center;
        }
      }
      .rate {
        width: 100%;
        height: $height - $info-height;
        line-height: $height - $info-height;
        text-align: center;
        background-color: #262831;
        color: #e1bf7e;
        font-size: 0.2rem;
      }
      &.active {
        .rate {
          background-color: #fff;

          span {
            background-image: -webkit-linear-gradient(
              -104deg,
              #5c1413,
              #e04445
            );
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }
      }
    }
  }
  .option-all-pop {
    width: 70%; //11.1rem;
    max-height: 70%; //4.48rem;
    background: url(./imgs/option-pop-bg.png) no-repeat;
    background-size: cover;
    background-position: 100% 100%;
    padding: 0.2rem 0;
    display: flex;
    flex-direction: column;

    .select-ctrl {
      margin-top: 0.1rem;
      text-align: center;
      position: relative;
      .done-btn {
        /* width: 1.77rem;
        height: 0.55rem;
        line-height: 0.55rem;
        font-size: 0.26rem;
        text-align: center;
        font-weight: 600; */
      }
      .close-btn {
        font-size: 0.44rem;
        position: absolute;
        right: 0.1rem;
        bottom: 0;
      }
    }

    .option-all-list {
      padding: 0 0.49rem;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      min-height: 0;
      overflow: auto;
      align-items: stretch;

      .scroll-box {
        // flex: 1;
        // display: flex;
        // flex-wrap: wrap;

        margin: 0 -0.1rem -0.5rem;
        justify-content: space-between;
      }

      .option-item {
        margin-left: 0.1rem;

        margin: 0 0.1rem 0.5rem;
        // &:first-child{
        //   margin-left:0;
        // }

        &.holder {
          // width: 0;
          padding-left: 0;
          padding-right: 0;
          margin: 0 0.1rem;
        }
        // &:nth-child(7n + 1){
        //   margin-left:0;
        // }
        //  margin-top:  0.1rem;
        // &:nth-child(-n + 7){
        //   margin-top:0;
        // }
      }
      .holder {
        height: 0;
      }
    }
  }

  .question-selected-mask {
    overflow: hidden;
    position: relative;
    $size: 0.5rem;
    $jian-ge: 0.1rem;
    &::after {
      content: "";
      position: absolute;
      display: block;
      width: 150%;
      height: $jian-ge;
      border-top: $size solid rgba(#ffd737, 0.4);
      border-bottom: $size solid rgba(#ffeda4, 0.6);
      top: 120%;
      left: -20%;
      // background-color: rgba(#ffd737, 0.2);
      transform: rotate(15deg);
    }
    &.flash {
      &::after {
        transition: 0.3s linear;
        top: (-$size * 2 - $jian-ge) * 1.3;
      }
    }
  }
}

.quiz-result {
  width: 6.3rem;
  // height: 2.8rem;
  text-align: center;
  .name,
  .desc {
    display: block;
    width: 100%;
  }
  .name {
    font-size: 0.3rem;
    color: #fff;
    margin: 0.3rem 0;
  }
  .desc {
    font-size: 0.22rem;
    color: #cbcbcb;
  }
  .done-btn {
    height: 0.56rem;
    line-height: 0.56rem;
    width: 1.78rem;
    margin: 0.6rem auto 0.3rem;
    font-size: 0.26rem;
    font-weight: 600;
  }
}

.no-enought-gold {
  padding: 0.6rem 0 0;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  color: #fff;
  text-align: center;
  display: flex;
  flex-direction: column;
  span {
    margin: auto;
  }
  .done-btn {
    height: 0.56rem;
    line-height: 0.56rem;
    width: 2rem;
    margin: 0.6rem auto 0.3rem;
    font-size: 0.25rem;
    font-weight: 600;
    color: #282728;
  }
}
</style>
